module.exports = __webpack_public_path__ + "static/media/star.58abb9cd.svg";